
import { useQuery } from "@tanstack/react-query";
import { StaffAssignmentService, ClassStaffAssignment } from "@/services/classServices/staffAssignmentService";

export const useStaffClassAssignments = (staffId: string) => {
  return useQuery({
    queryKey: ['staffClassAssignments', staffId],
    queryFn: async () => {
      try {
        const assignments = await StaffAssignmentService.getAssignmentsByStaff(staffId);
        return assignments;
      } catch (error) {
        console.error('Error fetching staff class assignments:', error);
        return [] as ClassStaffAssignment[];
      }
    },
    enabled: !!staffId,
  });
};
